import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import axios from "axios";
import Navbar from "../components/Navbar";
import { VideoType } from "../utils/types";
import colors from "../utils/colors";
import "./style.css";

const initialValue: VideoType = {
  _id: "",
  camera: "",
  date: "",
  dateRough: "",
  insight: "",
  keywords: [""],
  suburb: "",
  name: "",
  orientation: "",
  postcode: "",
  provider: "",
  sensitivity: "",
  street: "",
  thumbnail: [""],
  videoURL: "",
  videoPreviewURL: "",
  duration: 0,
  locality: "",
  location: { type: "", coordinates: [] },
};

// Direct stream endpoint (no agreement access control) — same swap Preview uses.
const playable = (url: string) => url.replace("stream", "streamwithname");

function VideoView() {
  const { id } = useParams();
  const slsApi = process.env.REACT_APP_create_video_api;
  const [data, setData] = useState<VideoType>(initialValue);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${slsApi}/${id}`)
      .then((res) => setData(res.data))
      .catch((err) => setError(err?.message || "Could not load video"));
  }, [slsApi, id]);

  const hasFile = Boolean(data.videoURL && data.videoURL.split("name=")[1]);

  return (
    <div style={{ background: colors.SLSsecondary, minHeight: "100vh" }}>
      <Navbar />
      <div style={{ width: "90%", maxWidth: "900px", margin: "40px auto" }}>
        <h2 style={{ color: "whitesmoke" }}>
          {data.name ? data.name.toUpperCase() : "Video"}
        </h2>
        {error && <p style={{ color: "salmon" }}>{error}</p>}
        {!error && !hasFile && (
          <p style={{ color: "whitesmoke" }}>
            This record has no video file (upload never completed).
          </p>
        )}
        {hasFile && (
          <div className="player-wrapper">
            <ReactPlayer
              className="player"
              url={playable(data.videoPreviewURL || data.videoURL)}
              playing={false}
              controls={true}
              width="100%"
            />
          </div>
        )}
        {data.insight && (
          <p style={{ color: "whitesmoke", marginTop: "20px" }}>
            {data.insight}
          </p>
        )}
      </div>
    </div>
  );
}

export default VideoView;
